import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../services/configuration.service';

@Injectable({
    providedIn: 'root',
})
export class MediaLibraryHttpService {
    constructor(private configurations: ConfigurationService, private http: HttpClient) {}

    getAllFolders(): Observable<any> {
        return this.http.get<any>(`${this.configurations.baseUrl}/api/mediaLibrary/getAllFolders`);
    }

    getFolderAssets(params?: any): Observable<any> {
        return this.http.get<any>(`${this.configurations.baseUrl}/api/mediaLibrary/getFolderAssets`, { params: params });
    }

    newFolder(folder: any): Observable<any> {
        return this.http.post<any>(`${this.configurations.baseUrl}/api/mediaLibrary/newFolder`, folder);
    }

    deleteFolder(folderId: any): Observable<any> {
        return this.http.delete<any>(`${this.configurations.baseUrl}/api/mediaLibrary/deleteFolder`, { params: { folderId: folderId } });
    }

    upload(formData: any, folderId: any): Observable<any> {
        return this.http.post<any>(`${this.configurations.baseUrl}/api/mediaLibrary/upload`, formData, { params: { folderId: folderId } });
    }

    deleteAsset(assetId: any): Observable<any> {
        return this.http.delete<any>(`${this.configurations.baseUrl}/api/mediaLibrary/deleteAsset`, { params: { assetId: assetId } });
    }

    deleteAssetBulk(ids: any): Observable<any> {
        return this.http.delete<any>(`${this.configurations.baseUrl}/api/mediaLibrary/deleteAssetBulk`, { params: { ids: ids } });
    }

    editAsset(assetName: any, assetId: any): Observable<any> {
        return this.http.put<any>(
            `${this.configurations.baseUrl}/api/mediaLibrary/editAsset`,
            {},
            { params: { assetId: assetId, assetName: assetName } }
        );
    }
}
